module.exports = __webpack_public_path__ + "img/nonwood_grey_en.295b9fa7.svg";